'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.AuthenticationService
 * @description
 * # authentication.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .factory('authInterceptorService', ['$q', '$injector', '$location', 'localStorageService',
    function($q, $injector, $location, localStorageService) {

      var authInterceptorServiceFactory = {};

      var _request = function(config) {

        if (!config.ignore) {
          config.headers = config.headers || {};

          var authData = localStorageService.get('authorizationData');
          if (authData) {
            config.headers.Authorization = 'Bearer ' + authData.token;
          }
        }

        return config;
      };

      var _responseError = function(rejection) {
        switch (rejection.status) {
          case 401:
            handle401Rejection(rejection);
            break;
          case 404:
            handle404Rejection(rejection);
            break;
          default:

        }
        return $q.reject(rejection);
      };

      function handle401Rejection(rejection) {
        var authService = $injector.get('AuthenticationService');
        var authData = localStorageService.get('authorizationData');

        if (authData) {
          if (authData.useRefreshTokens) {
            $location.path('/refresh');
            return $q.reject(rejection);
          }
        }
        authService.Logout();
        $location.path('/login');
      }

      function handle404Rejection(rejection) {
        $location.path('/404');
      }

      authInterceptorServiceFactory.request = _request;
      authInterceptorServiceFactory.responseError = _responseError;

      return authInterceptorServiceFactory;
    }
  ]);
